@if (isLoading()) {
<div class="flex items-center justify-center min-h-[300px]">
    <p-progress-spinner ariaLabel="loading header" />
</div>
} @else {

@if(searchResult())
{
@if (auctions().length > 0 && items().length > 0) {
<app-search-combined [searchResult]="searchResult()" [query]="query" (favoriteStatus)="onFavoriteChanged($event)"
    (myAuctionChanged)="onMyAuctionsChanged($event)"></app-search-combined>

} @else if (items().length > 0) {
<app-items-only [query]="query"></app-items-only>

} @else {
<app-no-result [query]="query"></app-no-result>
}

}

}